export const programs = [
  {
    "id": "legacy-media-archive",
    "slug": {
      "en": "media-archive",
      "es": "archivo-de-medios",
      "nl": "media-archief",
      "pap": "archivo-di-media"
    },
    "title": {
      "en": "Media Archive",
      "es": "Archivo de Medios",
      "nl": "Media-archief",
      "pap": "Archivo di Media"
    },
    "subtitle": {
      "en": "A public archive of video and podcast study material.",
      "es": "Un archivo publico de materiales de estudio en video y podcast.",
      "nl": "Een publiek archief van video- en podcaststudiemateriaal.",
      "pap": "Un archivo publiko di material di estudio di video i podcast."
    },
    "language": "en",
    "description": {
      "en": "Browse media titles, descriptions, images, links, and embeds as study material.",
      "es": "Explora titulos, descripciones, imagenes, enlaces e inserciones multimedia como material de estudio.",
      "nl": "Bekijk mediatitels, beschrijvingen, beelden, links en embeds als studiemateriaal.",
      "pap": "Wak titulonan, deskripshonnan, imahennan, linknan i embeds di media komo material di estudio."
    },
    "canonicalQuestion": {
      "en": "Which transmissions should be studied now and later organized into deeper sequences?",
      "es": "Que transmisiones deben estudiarse ahora y luego organizarse en secuencias mas profundas?",
      "nl": "Welke uitzendingen moeten nu worden bestudeerd en later in diepere reeksen worden geordend?",
      "pap": "Ki transmishonnan mester wordu studia awor i despues ordena den sekuensianan mas profundo?"
    },
    "transformationPurpose": {
      "en": "Keep the archive available for study while deeper sequencing continues.",
      "es": "Mantener el archivo disponible para el estudio mientras continua la secuencia mas profunda.",
      "nl": "Houd het archief beschikbaar voor studie terwijl de diepere ordening doorgaat.",
      "pap": "Tene e archivo disponibel pa estudio mientras e ordenashon mas profundo ta sigui."
    },
    "status": "completed",
    "image": null,
    "imageAlt": null,
    "seasons": [
      "legacy-media-preservation-season"
    ],
    "relatedCourses": [],
    "relatedArticles": []
  }
];
